import { useEffect, useState } from 'react';
import { fetchInvisibleNotification } from '../service';
import { NotificationData } from '../model/NotificationData';

export const useFetchNotification = () => {
  const [notificationData, setNotificationData] = useState<NotificationData>(
    {},
  );
  useEffect(() => {
    const fetchData = async () => {
      const notificationData = await fetchInvisibleNotification(
        'NEW_USER_CONNECTION',
      );
      setNotificationData(notificationData);
    };
    fetchData();
  }, []);
  return { notificationData, setNotificationData };
};
